export enum PrimaryIntegrationOption {
  Clever = "Clever",
  Classlink = "Classlink",
  OneRoster = "OneRoster Bulk Rostering",
  Other = "Other",
}
